import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import "./SceletonChat.scss"

const SceletonChat = ({ key }) => {

    return (
        <div className="sceleton-chat">
            <Stack className="sceleton-chat__content">
                <div className="sceleton-chat__message">
                    <Skeleton
                        className="round"
                        variant="circular"
                        width={32}
                        height={32}
                    />
                    <Skeleton
                        variant="rectangular"
                        width={'100%'}
                        height={150}
                    >
                        <Skeleton variant="circular" width={32} height={32} />
                    </Skeleton>
                </div>

                <div className="sceleton-chat__message">
                    <Skeleton
                        variant="rectangular"
                        width={'100%'}
                        height={130}
                    />
                    <Skeleton
                        className="round"
                        variant="circular"
                        width={32}
                        height={32}
                    />
                </div>

                <div className="sceleton-chat__message">
                    <Skeleton
                        className="round"
                        variant="circular"
                        width={32}
                        height={32}
                    />
                    <Skeleton variant="rectangular" width={'100%'} height={80}>
                        <Skeleton variant="circular" width={32} height={32} />
                    </Skeleton>
                </div>

                <div className="sceleton-chat__message">
                    <Skeleton
                        variant="rectangular"
                        width={'100%'}
                        height={40}
                    />
                    <Skeleton
                        className="round"
                        variant="circular"
                        width={32}
                        height={32}
                    />
                </div>
            </Stack>
        </div>
    )
}

export { SceletonChat }